module.exports = __webpack_public_path__ + "img/9788996697947.5e008fac.jpg";